import { InjectionToken } from '@angular/core';
import { AbstractJobService } from '@y42/job';

export const FeatureChildJobServiceInjectionToken = new InjectionToken<AbstractJobService[]>(
  'FeatureChildJobServiceInjectionToken',
);
